import { PagingRequest } from '../common/paging';

export class TrainingSearchModel extends PagingRequest {
    customerId: number;
}

export class TrainingSummaryDto {
    id: number;
    title: string;
    eventDateTime: string;
    jsEventDateTime: string;
    jsEventDateStartEnd: string;
    jsEventDate: string;
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/models/training/training.search.models.ts